const angular = require('angular');
const app = angular.module('learn-resources');

/**
 * Invitations Resource
 * @argument {$resource} $resource injected to define a resource api
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.factory('Invitations', ['$resource', 'appConfiguration', function ($resource, appConfiguration) {

  return $resource(appConfiguration.apiUrl + '/learn/v3/invitations/:subresource/:remind', null, {
    accept: {params: {subresource: 'accept'}, method: 'POST', isArray: false},
    find: {params: {subresource: ''}, method: 'GET', isArray: true},
    openFind: {params: {subresource: 'find'}, method: 'GET', isArray: true},
    get: {params: {subresource: ''}, method: 'GET', isArray: false},
    count: {params: {subresource: 'count'}, method: 'GET', isArray: false},
    create: {params: {subresource: ''}, method: 'POST', isArray: false},
    remind: {params: {subresource: '', remind: 'remind'}, method: 'POST', isArray: false},
    bulkInvite: {params: {subresource: 'bulk'}, method: 'POST', isArray: false},
    remove: {params: {subresource: ''}, method: 'DELETE', isArray: false}
  });
}]);
